import {
  ACTION_CARD_COMPOSER_ASK,
  ACTION_CARD_MENTION_KIND,
  actionCardComposerText,
  mentionChipNodes,
  narrowCardContent,
} from '@littlebird/action-cards';

import { type MentionItem, type MentionSource } from '@/features/mention';

import { ActionCardMentionIcon } from './components/ActionCardMentionIcon';

import type { ActionCard } from '@littlebird/sdk';
import type { JSONContent } from '@tiptap/core';

type ActionCardComposerDraft = {
  content: string;
  draftDocument: JSONContent;
};

export const mentionedActionCardIds = (
  mentions: readonly MentionItem[]
): string[] =>
  mentions.flatMap(({ kind, id }) =>
    kind === ACTION_CARD_MENTION_KIND ? [id] : []
  );

export const mentionedActionCardId = (
  mentions: readonly MentionItem[]
): string | undefined => {
  const [cardId, ...otherCardIds] = mentionedActionCardIds(mentions);
  return otherCardIds.length === 0 ? cardId : undefined;
};

export const createActionCardSource = (): MentionSource => ({
  kind: ACTION_CARD_MENTION_KIND,
  title: 'Action card',
  listItems: () => Promise.resolve([]),
  renderIcon: (mention) => <ActionCardMentionIcon cardId={mention.id} />,
});

const mentionParagraph = (card: ActionCard, title: string): JSONContent => ({
  type: 'paragraph',
  content: mentionChipNodes(card, title),
});

export const actionCardComposerDraft = (
  card: ActionCard
): ActionCardComposerDraft | null => {
  const content = narrowCardContent(card.actionType, card.content);
  if (content?.type !== 'informational') return null;

  return {
    content: actionCardComposerText(content.title),
    draftDocument: {
      type: 'doc',
      content: [
        mentionParagraph(card, content.title),
        {
          type: 'paragraph',
          content: [{ type: 'text', text: ACTION_CARD_COMPOSER_ASK }],
        },
      ],
    },
  };
};
